function c(t,n){const e=Object.assign({},t);return n.forEach(o=>{delete e[o]}),e}export{c as omitKeys};
